import { Grid2, LinearProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RootStyled = styled(Grid2)({
  position: 'fixed',
  top: '10em',
  right: '4em',
  zIndex: 3,
  padding: '32px 24px',
  borderRadius: '8px',
  boxShadow: '0px 3px 6px gray',
  backgroundColor: '#FFFFFF',
  width: '22em',
  height: '25em',
});

export const ProgressRootStyled = styled(LinearProgress)({
  height: '1em',
});

export const LinearProgressStyled = styled(LinearProgress)(() => ({
  height: '1em',
  '& .MuiLinearProgress-barColorPrimary': {
    backgroundColor: '#1d6fbb',
  },
}));

export const CustomScrollbarStyled = styled(Grid2)({
  maxHeight: '14em',
  paddingLeft: '5px',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f1f1f1',
  },
});

export const IconStyled = styled('span')({
  borderRadius: '50%',
  width: 24,
  height: 24,
  boxShadow:
    'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: '#f5f8fa',
  backgroundImage:
    'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '&.Mui-focusVisible': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: 'rgba(206,217,224,.5)',
  },
});

export const CheckedIconStyled = styled(IconStyled)({
  backgroundColor: '#22b07d',
  backgroundImage:
    'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 24,
    height: 24,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#22b07d',
  },
});
